export class TravelSheetModel {
  advanceApprover: ApproverModel;
  advanceTaken: number;
  airAmount: number;
  airGstAmount: number;
  noOfPersons: number;
  approver: ApproverModel;
  carAmount: number;
  chargeble: boolean;
  client: clientModel;
  assignment: AssignmentModel;
  entryDate: any;
  fareDocuments: FareDocumentModel[];
  foodAmount: number;
  foodGstAmount: number;
  fromDate: any;
  fy: FYModel;
  hotelAmount: number;
  hotelGstAmount: number;
  id: number;
  kms: number;
  natureOfExpense: string;
  netPayable: number;
  otherAmount: number;
  otherGstAmount: number;
  remark: string;
  sheetStatus: string;
  taxiAmount: number;
  taxiGstAmount: number;
  toDate: any;
  toll: number;
  totalAmount: number;
  trainAmount: number;
  trainGstAmount: number;
  mobileAmount: number;
  mobileGstAmount: number;
  internetAmount: number;
  internetGstAmount: number;
  icaiMembershipFee: number;
  icaiMembershipGstAmount: number;
  microsoft365Subscription: number
  microsoft365SubscriptionGstAmount: number;
  seminarFee: number;
  seminarFeeGstAmount: number;
  user: UserModel;

  // get totalAmounts():number{
  // this.totalAmount=0;
  // if(this.trainAmount!=undefined){
  //   this.totalAmount=this.trainAmount;
  // }
  // if(this.airAmount!=undefined){
  //   this.totalAmount+=this.airAmount;
  // }
  // if(this.taxiAmount!=undefined){
  // this.totalAmount+=this.taxiAmount;
  // }
  // if(this.carAmount!=undefined){
  //  this.totalAmount+=this.carAmount;
  // }
  // if(this.hotelAmount!=undefined){
  //  this.totalAmount+=this.hotelAmount;
  // }
  // if(this.toll!=undefined){
  //   this.totalAmount+=this.toll;
  // }
  // if(this.foodAmount!=undefined){
  //   this.totalAmount+=this.foodAmount;
  // }
  // if(this.otherAmount!=undefined){
  //   this.totalAmount+=this.otherAmount;
  // }
  //   return this.totalAmount;
  // }

  // get netPayableAmount():number{
  //   this.netPayable=0;
  //   // if(this.netPayable!=undefined){
  //    this.netPayable=this.totalAmount-this.netPayable;
  //   // }
  //   return this.netPayable;
  // }

}
export class ApproverModel {
  email: string;
  firstName: string;
  id: number;
  lastName: string;
  middleName: string;
  userId: string
}
export class FareDocumentModel {
  id: number;
  type: string;
  url: string
}

// export class AdvanceApproverModel{
// email: string;
// firstName: string;
// id: number;
// lastName: string;
// middleName: string;
// userId: string
// }

export class UserModel {
  email: string;
  firstName: string;
  id: number;
  lastName: string;
  middleName: string;
  userId: string
}

export class clientModel {
  branch: {
    address: string;
    contactNo: string;
    id: number;
    name: string;
    offDays: [
      string
    ]
  }
  ediaryStatus: {
    id: number;
    name: string
  };
  id: number;
  legalStatus: {
    id: number;
    name: string
  };
  name: string;
  chargeableToClient: boolean;
}

export class AssignmentModel {
  id: number;
  isCheckListRequired: boolean;
  name: string;
}

export class FYModel {
  endDate: Date;
  id: number;
  name: string;
  startDate: Date
}



